import { makeStylesV5 } from '../index';
export default makeStylesV5()(() => ({
    AppBadge: {
        display: 'inline-flex',
        fontWeight: 700,
        padding: '2px 5px',
        margin: '5px',
        fontSize: '12px',
        borderRadius: '4px'
    }
}));
//# sourceMappingURL=styles.js.map